import toast from "react-hot-toast";

export const errorToast = (msg) => {
  toast.error(msg, { duration: 2000, position: "top-center" });
};

export const successToast = (msg) => {
  toast.success(msg, { duration: 2000, position: "top-center" });
};

export const toastInfo = (msg) => {
  toast(msg, { position: "top-center", duration: 2000 });
};
